var React = require('react');

function XCircleOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M 12,21.580789 C 6.7185901,21.580789 2.419211,17.28141 2.419211,12 2.419211,6.7185901 6.7185901,2.419211 12,2.419211 c 5.28141,0 9.580789,4.2993791 9.580789,9.580789 0,5.28141 -4.299379,9.580789 -9.580789,9.580789 z M 12,0.02401372 C 5.3772796,0.02401372 0.02401372,5.3772796 0.02401372,12 0.02401372,18.62272 5.3772796,23.975986 12,23.975986 18.62272,23.975986 23.975986,18.62272 23.975986,12 23.975986,5.3772796 18.62272,0.02401372 12,0.02401372 Z M 15.10178,7.2096055 12,10.311386 8.8982196,7.2096055 7.2096055,8.8982196 10.311386,12 7.2096055,15.10178 8.8982196,16.790395 12,13.688614 15.10178,16.790395 16.790395,15.10178 13.688614,12 16.790395,8.8982196 Z","style":{"strokeWidth":"1.1976"}}));
}

XCircleOutline.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = XCircleOutline;

XCircleOutline.default = XCircleOutline;
